<template>
  <div class="field-container">
    <label v-if="label" :for="id" class="form-label">
      {{ alreadyTranslated ? label : $t(`forms.${label}`) }} {{ showAsterisk }}
    </label>

    <div class="row">
      <select
        :disabled="disabled"
        :id="id"
        class="form-input"
        v-validate="this.validate !== '' ? this.validate : false"
        v-bind:value="value"
        @change="$emit('change', $event.target.value)"
      >
        <!-- <option :value="'placeholder'" selected="selected" disabled="disabled"> -->
        <!-- {{ $t('forms.defaultSelectValue') }} -->
        <!-- </option> -->

        <option v-for="option in options" v-bind:value="option.value" :key="option.value">
          {{ alreadyTranslated ? option.text : $t(option.text) }}
        </option>
      </select>
    </div>
  </div>
</template>

<script>
export default {
  name: 'VvFormSelectInput',
  computed: {
    showAsterisk() {
      if (this.validate && this.validate.indexOf('required') !== -1) {
        return '*'
      }

      return ''
    }
  },
  data: () => ({
    isValid: false
  }),
  props: {
    id: {
      type: String
    },
    value: {
      type: String
    },
    label: {
      type: String,
      default: ''
    },
    options: {
      type: Array,
      default: () => []
    },
    validate: {
      type: String,
      default: null
    },
    disabled: {
      type: Boolean,
      default: false
    },
    alreadyTranslated: {
      type: Boolean,
      default: false
    }
  },
  inject: ['$validator'],
  model: {
    prop: 'value',
    event: 'change'
  },
  watch: {
    async value(newValue) {
      if (this.validate === '') {
        this.isValid = newValue !== 'placeholder'
      } else {
        this.isValid = (await this.$validator.verify(newValue, this.validate)).valid
      }
    }
  }
}
</script>

<style scoped lang="scss">
.form-input {
  height: 32px;
  border-radius: 5px;
  background-color: #f6f6f6;
  padding: 9px 13px;
  font-family: Avenir;
  font-size: 10.8px;
  font-weight: 900;
  width: 100%;
  color: #4a4a4a;
  border: none;
}

.form-label {
  text-align: left;
  margin-bottom: 6px;
}

.valid-field {
  float: right;
  height: 14px;
  object-fit: contain;
  padding: 10px;
}

.row {
  display: flex;
  justify-content: space-between;
}

.field-container {
  display: flex;
  flex-direction: column;
}

.form-error {
  display: block;
  color: red;
  margin-top: 4px;
  font-size: 10px;
  text-align: left;
}
</style>
